import type { ReactNode } from 'react'
import cx from 'classnames'
import { match } from '@/utils/pattern-match-util'
import styles from './CellText.module.css'

export interface CellTextProps {
  children?: ReactNode
  variant: 'truncate' | 'tabular' | 'mono' | 'empty'
  tone?: 'default' | 'warning' | 'danger'
  title?: string
}

/**
 * Text inside a {@link DataTable} cell.
 */
export function CellText({
  children,
  variant,
  tone = 'default',
  title,
}: CellTextProps) {
  return (
    <span
      className={cx(
        match(variant, {
          truncate: () => styles.truncate,
          tabular: () => styles.tabular,
          mono: () => styles.mono,
          empty: () => styles.empty,
        }),
        match(tone, {
          default: () => null,
          warning: () => styles.warning,
          danger: () => styles.danger,
        }),
      )}
      title={title}
    >
      {children}
    </span>
  )
}
